<template>
  <BreadCrumb PageTitle="Paramètres du compte" />
  <TypeClientSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TypeClientSettings from "@/components/Generals/AccountSettings/TypeClientSettings.vue";

export default defineComponent({
  name: "TypeClientSettingsPage",
  components: {
    BreadCrumb,
    TypeClientSettings,
  },
});
</script>